module.exports = __webpack_public_path__ + "media/configurations/SX-O-d2b0aeb0.png";